import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    journeys: {
      leave_story: null,
    },
    visibleSlides: ['record-of-support'],
    // visibleSlides: ['record-of-support', 'donate', 'meet-ask', 'meet-your-mp', 'share', 'will-share', 'tell-your-mp', 'thanks'],
    signups: 0,
    user: {
      firstname: null,
      email: null,
      postcode: null,
      optin: null
    },
    mp: {
      name: "",
      constituency: "",
      priority: ""
    },
  },
  mutations: {
    updateMP(state, payload) {
      state.mp = payload
    },
    updateUser(state, payload) {
      state.user = payload
    },
    setSignups(state, payload) {
      state.signups = payload
    },
    updateJourney(state, payload) {
      state.journeys[payload.journey] = payload.result
    },
  },
  actions: {

  },
  getters: {
    getTarget(state) {
      const n = state.signups
      let total;
      switch (true) {
        case n < 1000:
          total = 5000
          break
        case n >= 1000 && n < 5000:
          total = 10000
          break
        case n >= 5000 && n < 10000:
          total = 20000
          break
        case n >= 10000 && n < 50000:
          total = 100000
          break
        case n >= 50000 && n < 150000:
          total = 200000
          break
        case n >= 150000 && n < 200000:
          total = 250000
          break
        case n >= 200000 && n < 300000:
          total = 350000
          break
        case n >= 300000 && n < 400000:
          total = 450000
          break
        case n >= 400000 && n < 500000:
          total = 550000
          break
        case n >= 500000 && n < 1000000:
          total = 1000000
          break
        case n >= 1000000 && n < 2000000:
          total = 2000000
          break
        case n >= 2000000 && n < 3000000:
          total = 3000000
          break
        case n >= 3000000 && n < 4000000:
          total = 4000000
          break
        case n >= 4000000 && n < 5000000:
          total = 5000000
          break
        case n >= 5000000 && n < 6000000:
          total = 6000000
          break
        case n >= 6000000 && n < 7000000:
          total = 7000000
          break
        case n >= 8000000 && n < 9000000:
          total = 9000000
          break
        case n >= 9000000 && n < 10000000:
          total = 10000000
          break
        default:
          total = 20000000
      }
      return total;
    },
    getProgress(state, getters) {
      return (state.signups / getters.getTarget * 100)
    },
    getSignups(state) {
      return numberWithCommas(state.signups)
    },
    getTargetWithCommas(state, getters) {
      return numberWithCommas(getters.getTarget)
    }
  }
})


function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}